export const isMobile = (): boolean => window.innerWidth <= 768;